import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Styles } from '../../../css/table';
import { TablePagination } from '../../common/table/tablePagination';
import { jigsawPuzzleConfigColumn } from '../../common/table/TableColumns/jigsawPuzzleConfig';

const JigsawPuzzleTable = ({ pageCount, fetchData }) => {
  const { jigsawPuzzleConfigs } = useSelector(state => state.gameConfig);

  return (
    <div className="w-full h-full">
      <Styles>
        <TablePagination
          columns={jigsawPuzzleConfigColumn}
          data={jigsawPuzzleConfigs?.data || []}
          total_item={jigsawPuzzleConfigs?.total_items}
          fetchData={fetchData}
          pageCount={pageCount}
          className="rounded"
        />
      </Styles>
    </div>
  );
};
JigsawPuzzleTable.propTypes = {
  fetchData: PropTypes.func,
  pageCount: PropTypes.number,
};
export default JigsawPuzzleTable;
